/* @flow */

import * as React from 'react';
import { Field } from 'formik';
import { useIntl } from 'react-intl';

import FormikFormGroup from 'src/shared/app/base/component/data-entry/form/FormikFormGroup';
import { getFieldTitle } from 'src/shared/app/base/component/data-entry/form-builder/utils/FormBuilderUtils';

import type { Field as FieldProps } from 'src/shared/app/base/component/data-entry/form-builder/type/formBuilderTypes';

const FormBuilderText = ({ field, name }: FieldProps): React.Node => {
  const intl = useIntl();

  return (
    <div>
      <Field
        id={name}
        name={name}
        rows="3"
        component={FormikFormGroup}
        componentOpts={{
          useTextareaMinify: true,
          label: getFieldTitle(field, intl),
          hasLengthCounter: true,
        }}
        maxLength={200}
      />
    </div>
  );
};

export default React.memo<FieldProps>(FormBuilderText);
